import get from "lodash/get";
import { createSelector } from "reselect";
import { NAMESPACE } from "../constants";
export const getPanelWidth = createSelector((state) => get(state, `[${NAMESPACE}].panelWidth`), (width) => width);
